export function HeaderScenicBackground() {
  return (
    <div
      className="absolute top-0 right-0 left-0 h-[220px] pointer-events-none select-none overflow-hidden -z-0 opacity-85"
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 1000 240"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-full object-cover object-right"
        preserveAspectRatio="xMaxYMin slice"
      >
        <defs>
          {/* Glowing sunrise radial gradient */}
          <radialGradient id="sunGlowGrad" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#FEF3C7" stopOpacity="1" />
            <stop offset="30%" stopColor="#FBBF24" stopOpacity="0.85" />
            <stop offset="65%" stopColor="#F59E0B" stopOpacity="0.35" />
            <stop offset="100%" stopColor="#F59E0B" stopOpacity="0" />
          </radialGradient>

          {/* Mountain gradients */}
          <linearGradient id="backMtnGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#BFDBFE" stopOpacity="0.5" />
            <stop offset="100%" stopColor="#DBEAFE" stopOpacity="0.1" />
          </linearGradient>

          <linearGradient id="midMtnGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#93C5FD" stopOpacity="0.65" />
            <stop offset="100%" stopColor="#EFF6FF" stopOpacity="0.2" />
          </linearGradient>

          <linearGradient id="nearMtnGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#60A5FA" stopOpacity="0.55" />
            <stop offset="100%" stopColor="#F8FAFC" stopOpacity="0.8" />
          </linearGradient>
        </defs>

        {/* Sunrise glowing orb positioned right over mountain peak */}
        <circle cx="705" cy="85" r="58" fill="url(#sunGlowGrad)" />
        <circle cx="705" cy="85" r="26" fill="#FDE68A" opacity="0.95" />

        {/* Distant mountain layer */}
        <path
          d="M400 180 Q 520 70, 620 120 T 705 70 T 830 115 L 1000 95 L 1000 240 L 400 240 Z"
          fill="url(#backMtnGrad)"
        />

        {/* Mid-range mountain layer */}
        <path
          d="M480 200 Q 590 100, 680 135 T 780 90 T 920 130 L 1000 135 L 1000 240 L 480 240 Z"
          fill="url(#midMtnGrad)"
        />

        {/* Foreground rolling ridge */}
        <path
          d="M560 210 Q 690 125, 770 155 T 880 118 T 1000 150 L 1000 240 L 560 240 Z"
          fill="url(#nearMtnGrad)"
        />
      </svg>
    </div>
  );
}

export function HeroMountainBackground() {
  return (
    <div
      className="absolute inset-0 pointer-events-none select-none overflow-hidden"
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 900 340"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-full object-cover object-right-bottom"
        preserveAspectRatio="xMaxYMax slice"
      >
        <defs>
          {/* Deep midnight sky gradient */}
          <linearGradient id="heroSky" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#121B2D" />
            <stop offset="60%" stopColor="#162238" />
            <stop offset="100%" stopColor="#1B2B47" />
          </linearGradient>

          {/* Ambient sunrise glow in distance */}
          <radialGradient id="heroGlow" cx="75%" cy="30%" r="60%">
            <stop offset="0%" stopColor="#38BDF8" stopOpacity="0.25" />
            <stop offset="40%" stopColor="#1E3A8A" stopOpacity="0.15" />
            <stop offset="100%" stopColor="#0F172A" stopOpacity="0" />
          </radialGradient>

          {/* Mountain silhouettes */}
          <linearGradient id="heroMtn1" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#243452" stopOpacity="0.8" />
            <stop offset="100%" stopColor="#131C2E" stopOpacity="0.9" />
          </linearGradient>

          <linearGradient id="heroMtn2" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#19253C" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#0F172A" stopOpacity="1" />
          </linearGradient>

          <linearGradient id="heroMtn3" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#101827" />
            <stop offset="100%" stopColor="#0B101D" />
          </linearGradient>
        </defs>

        {/* Base sky fill */}
        <rect width="900" height="340" fill="url(#heroSky)" />
        <rect width="900" height="340" fill="url(#heroGlow)" />

        {/* Background mountains */}
        <path
          d="M380 250 L 520 170 L 620 220 L 730 140 L 850 200 L 900 180 L 900 340 L 380 340 Z"
          fill="url(#heroMtn1)"
        />

        {/* Mid mountains */}
        <path
          d="M480 270 L 610 190 L 700 230 L 790 155 L 880 220 L 900 210 L 900 340 L 480 340 Z"
          fill="url(#heroMtn2)"
        />

        {/* Foreground sharp peak */}
        <path
          d="M580 300 L 680 225 L 750 265 L 820 195 L 900 245 L 900 340 L 580 340 Z"
          fill="url(#heroMtn3)"
        />
      </svg>
    </div>
  );
}
